module.exports = "/assets/data/dc1e54fce71dcddbf6566d9e764a738f-CV34.data.json";